module.exports = __webpack_public_path__ + "static/img/whitetitle6s.695709f3.png";